import React from "react";

const RegistrationReviewTypeSwitch = ({ activeType, onChange, text }) => (
  <nav
    className="registration-review-type-switch"
    aria-label={text.registrationReviewType}
  >
    <button
      type="button"
      aria-pressed={activeType === "customers"}
      onClick={() => onChange("customers")}
    >
      <span className="registration-review-type-icon" aria-hidden="true">
        <i className="fa-solid fa-user" />
      </span>
      <span>{text.customers}</span>
    </button>
    <button
      type="button"
      aria-pressed={activeType === "merchants"}
      onClick={() => onChange("merchants")}
    >
      <span className="registration-review-type-icon" aria-hidden="true">
        <i className="fa-solid fa-store" />
      </span>
      <span>{text.merchants}</span>
    </button>
  </nav>
);

export default RegistrationReviewTypeSwitch;
